import { useState, useEffect } from "react";
import { GenerateFormattedDate } from "../../Components/Utils/Date/GenerateFormattedDate";
import { useGetDeviceConsumentLogsforReportMutation } from "../../store/storageRoles/devicesSharedApi";
import { useGetDealerRolesDeviceConsumentLogsforReportMutation } from "../../store/dealerRoles/devicesApi";
import useAuth from "../useAuth";

export const useDeviceConsumentReportData = (id, token) => {
  const { auth } = useAuth();
  const isDealer = auth?.role === "dealer";
  const [info, setInfo] = useState(false);
  const [input, setInput] = useState({
    id: id,
    token: token,
    type: "Consument",
    createdInfo: "",
    createdInfoSecond: "",
    productName: "",
  });
  const [filterType, setFilterType] = useState("Day");
  const [date, setDate] = useState(new Date());
  const [dateSecond, setDateSecond] = useState(new Date());
  const [paginationNumber, setPaginationNumber] = useState(1);
  const [
    getStorageDeviceConsumentLogsforReport,
    { data: storageData, isFetching: storageIsFetching, isLoading: storageIsLoading, isError: storageIsError, error: storageError },
  ] = useGetDeviceConsumentLogsforReportMutation();
  const [
    getDealerDeviceConsumentLogsforReport,
    { data: dealerData, isFetching: dealerIsFetching, isLoading: dealerIsLoading, isError: dealerIsError, error: dealerError },
  ] = useGetDealerRolesDeviceConsumentLogsforReportMutation();

  const getDeviceConsumentLogsforReport = isDealer
    ? getDealerDeviceConsumentLogsforReport
    : getStorageDeviceConsumentLogsforReport;
  const data = isDealer ? dealerData : storageData;
  const isFetching = isDealer ? dealerIsFetching : storageIsFetching;
  const isLoading = isDealer ? dealerIsLoading : storageIsLoading;
  const isError = isDealer ? dealerIsError : storageIsError;
  const error = isDealer ? dealerError : storageError;

  const [Datas, setDatas] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    // Consument data işleme
    if (data?.data) {
      setDatas(
        data.data.filter((item) => item.logs && item.logs.length > 0) || []
      );
    }
  }, [data]);

  useEffect(() => {
    setInput((prev) => ({ ...prev, createdInfo: GenerateFormattedDate(date) }));
  }, [date]);

  useEffect(() => {
    setInput((prev) => ({
      ...prev,
      createdInfoSecond: GenerateFormattedDate(dateSecond),
    }));
  }, [dateSecond]);

  const handleFilterType = (type) => {
    setFilterType(type);
  };

  const handleGetLogData = (productName = "") => {
    if (input.createdInfo && input.createdInfoSecond && input.id) {
      const requestData = {
        id: input.id,
        createdInfo: input.createdInfo,
        createdInfoSecond: input.createdInfoSecond,
        productName: productName || input.productName,
        token: input.token,
      };

      // Önce mevcut verileri temizle
      setDatas([]);

      // Consument raporu için endpoint çağır
      getDeviceConsumentLogsforReport(requestData);
    }
  };

  return {
    info,
    setInfo,
    input,
    setInput,
    filterType,
    handleFilterType,
    date,
    setDate,
    dateSecond,
    setDateSecond,
    paginationNumber,
    setPaginationNumber,
    isFetching,
    isLoading,
    isError,
    error,
    Datas,
    selectedDate,
    setSelectedDate,
    handleGetLogData,
  };
};
